import { ReviewQuote, ReviewStats } from '../types/review.types';

export const publicationReviewStats: ReviewStats = {
    rating: 5,
    totalReviews: 8
};

export const publicationReviews: ReviewQuote[] = [
    {
        text: "We need more ingenious designs like this for products that respect our planet.",
        publication: {
            name: 'Guardian',
            logo: '/assets/feature_logos/guardian.png'
        }
    },
    {
        text: "Their selling point, really, is the ethos behind them: encouraging young people to be considerate consumers.",
        publication: {
            name: 'Financial Times',
            logo: '/assets/feature_logos/financial_times.png'
        }
    },
    {
        text: "With several kids that like to construct and deconstruct everything, the attraction of the Kibu headphones, which are designed to be built and repaired by kids themselves, was immediately clear.",
        publication: {
            name: 'Dezeen',
            logo: '/assets/feature_logos/dezeen.png'
        }
    },
    {
        text: "These customisable children’s headphones are a first step into the essential world of circular design.",
        publication: {
            name: 'Wallpaper',
            logo: '/assets/feature_logos/wallpaper.png'
        }
    },
    {
        text: "The future of consumer electronics is here.",
        publication: {
            name: 'Autodesk',
            logo: '/assets/feature_logos/autodesk.png'
        }
    },
    {
        text: "A modular design not only allows broken parts to be replaced, but enables the product to “grow” with the child.",
        publication: {
            name: 'Design Week',
            logo: '/assets/feature_logos/design_week.png'
        }
    }
]; 